import API from '@/api.js'
export async function getNoticeDocContent(id){
	if(!id)return ''
	try{
		let res=await API.get(API.fileurl.getNoticeDocContent+id)
		return res.data.data ||''
	}catch{
		return ''
	}
}